import { useTranslation } from 'react-i18next';
import { SelectNetwork } from '../../../components';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';

import { SelectedUSDT } from '../../Marketplace/Marketplace.styled';

import { akashaWallets, copyLink } from '../../../helpers/helperFunctions';
import { TokensType, WalletsType } from '../../../types/types';

import walletImage from '../../../assets/icons/backOffice/Packages/wallet.svg';

import { SelectedTokenDeposit } from '../../Marketplace/Akasha/SelectedTokenDeposit';

interface Step1Props {
  wallet: string;
  token: TokensType;
  selectedNetwork: WalletsType;
}

export const Step2 = ({ wallet, token, selectedNetwork }: Step1Props) => {
  const { t } = useTranslation('packages');

  return (
    <>
      <P3 bold mb='8' color={color.colors.neutral900}>
        Selected Blockchain
      </P3>
      <SelectNetwork
        disabled
        onChange={(n) => {}}
        value={selectedNetwork ? selectedNetwork : akashaWallets[0]}
      />
      <P3 bold mb='8' color={color.colors.neutral900}>
        Selected Token For Deposit
      </P3>
      <SelectedTokenDeposit disabled onChange={(token) => {}} value={token} />

      <P3 bold mb='8' mt='40' color={color.colors.neutral900}>
        BACKOFFICE WALLET ADDRESS
      </P3>
      <SelectedUSDT
        onClick={() => {
          copyLink(wallet, t('waiting.copied'));
        }}
        style={{ cursor: 'pointer' }}>
        <div className='truncated'>
          <div>{wallet}</div>
        </div>

        <img
          src={walletImage}
          alt='withdraw'
          style={{ width: 16, marginLeft: 10 }}
        />
      </SelectedUSDT>
      <CaptionText color={colors.error500} mb='20' mt='20' bold>
        Disclaimer: Please ensure you deposit only the selected token for the
        Akasha Super Node. Deposits made in any other token will not be
        recognized or usable and may result in permanent loss of funds.
      </CaptionText>
    </>
  );
};
